import gql from 'graphql-tag';

// Multilingual v3: a new language for the project, from the editor's language box (founder 19.10.2026). Sysadmin-only
// in Hasura; offline until switched on, sorted after the others.
export default gql`
mutation addProjectLanguage($projectId: Int!, $languageId: Int!, $sort: Int!) {
  insert_project_languages_one(object: { project_id: $projectId, language_id: $languageId, sort: $sort }) {
    project_language_id
  }
}
`;
